import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const {
    login
  } = useUser();
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (login(email, password)) {
      navigate('/');
    } else {
      setError('Invalid email or password');
    }
  };
  return <div className="flex items-center justify-center min-h-screen bg-gray-100" data-id="element-277">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md" data-id="element-278">
        <div className="flex justify-center mb-6" data-id="element-279">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oCNg59UCgsypxdgQrDYR7c/pasted-image.png" alt="RowDate.com" className="h-20 w-auto" data-id="element-280" />
        </div>

        {error && <div className="border px-4 py-3 rounded mb-4" style={{
        backgroundColor: '#FEE2E2',
        borderColor: '#FE5757',
        color: '#991B1B'
      }} data-id="element-281">
            {error}
          </div>}
        <form onSubmit={handleSubmit} data-id="element-282">
          <div className="mb-4" data-id="element-283">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email" data-id="element-284">
              Email
            </label>
            <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Email" required data-id="element-285" />
          </div>
          <div className="mb-6" data-id="element-286">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password" data-id="element-287">
              Password
            </label>
            <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Password" required data-id="element-288" />
          </div>
          <div className="flex items-center justify-between" data-id="element-289">
            <button type="submit" className="text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full" style={{
            backgroundColor: '#4772B0'
          }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#3A5D8F'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#4772B0'} data-id="element-290">
              Sign In
            </button>
          </div>
        </form>
      </div>
    </div>;
};
export default Login;